import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Apollo} from "apollo-angular";
import {DisInputDataGqlModel, DisInputGqlModel, DisDeleteGqlModel} from "./dis.gql-model";

@Injectable({providedIn: "root"})
export class DisService {
  constructor(
    private http: HttpClient,
    private apollo: Apollo,
  ) {}

  async saveDis(dis: DisInputDataGqlModel[]): Promise<any> {
    const model = new DisInputGqlModel({dis});

    return this.apollo.mutate({mutation: model.mutation, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(DisInputGqlModel.mapper)
      .toPromise();
  }

  deleteDis(id: string): Promise<any> {
    const query = DisDeleteGqlModel.query;
    const model = new DisDeleteGqlModel({disId: id});

    return this.apollo.mutate({mutation: query, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(DisDeleteGqlModel.mapper)
      .toPromise();
  }
}
